var _class, _descriptor, _descriptor2, _descriptor3, _FormyComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import Ember from 'ember';
import { task } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
import FormyActions from './actions';
import FormyCheckbox from './checkbox';
import FormyDate from './date';
import FormyField from './field';
import FormyInput from './input';
import FormySearch from './search';
import FormySelect from './select';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component"; // TODO: add other hash fields and rename Hash
let FormyComponent = (_class = (_FormyComponent = class FormyComponent extends Component {
  constructor(owner1, args1) {
    super(owner1, args1);
    // Exiting the Formy is not only done by the form buttons
    // It could also happen when the user clicks on a link in the UI
    //
    // The Formy must then be informed when the router will transition
    // and in turn, alert the user if there are pending changes
    _initializerDefineProperty(this, "errors", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "validateAndSave", _descriptor3, this);
    this.router.on('routeWillChange', this.showPendingChangesetAlert);
  }
  async showPendingChangesetAlert(transition1) {
    if (this.args.changeset.isPristine) return;
    if (this.stayingOnSameRoute(transition1)) return;
    transition1.abort();
    const response1 = await this.errors.showPendingChangesetError();
    if (response1.isDismissed) return;
    // The user really want to loose its modifications
    this.args.changeset.rollback();
    transition1.retry();
  }
  stayingOnSameRoute(transition1) {
    return !!transition1.to?.find(r1 => r1.name === this.router.currentRouteName);
  }
  willDestroy() {
    this.router.off('routeWillChange', this.showPendingChangesetAlert);
    super.willDestroy();
  }
}, setComponentTemplate(precompileTemplate("\n    {{!-- prettier-ignore --}}\n    <form {{!-- @glint-expect-error --}} {{on \"submit\" (perform this.validateAndSave)}} ...attributes {{!-- @glint-expect-error --}} class=\"ui form {{if @changeset.isInvalid \"error\"}} {{if this.validateAndSave.isRunning \" loading\"}}\">\n      {{!-- @glint-expect-error --}}\n      {{yield (hash changeset=@changeset Actions=(component FormyActions formy=this) Field=(component FormyField formy=this) Input=(component FormyInput parent=this) Select=(component FormySelect parent=this) Date=(component FormyDate parent=this) Search=(component FormySearch parent=this) Checkbox=(component FormyCheckbox parent=this))}}\n    </form>\n  ", {
  strictMode: true,
  scope: () => ({
    on,
    perform,
    hash,
    FormyActions,
    FormyField,
    FormyInput,
    FormySelect,
    FormyDate,
    FormySearch,
    FormyCheckbox
  })
}), _FormyComponent), _FormyComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "validateAndSave", [task], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return function* (event1) {
      event1.preventDefault();
      // @ts-expect-error cannot type this…
      yield this.args.changeset.validate();
      // @ts-expect-error cannot type this…
      if (this.args.changeset.isInvalid) {
        // @ts-expect-error cannot type this…
        this.errors.displayError('Veuillez corriger les erreurs avant de sauvegarder !');
        return;
      }
      try {
        // @ts-expect-error cannot type this…
        yield this.args.changeset.save();
        // @ts-expect-error cannot type this…
        yield this.args.onSuccess?.();
      } catch (error1) {
        if (!Ember.testing) console.error(error1);
        // @ts-expect-error cannot type this…
        this.errors.displayError("Nous sommes désolés, une erreur est survenue et nous n'avons pas pu sauvegarder vos modifications");
      }
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "showPendingChangesetAlert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showPendingChangesetAlert"), _class.prototype), _class);
export { FormyComponent as default };